import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

import { filter } from "@/utils/vueFilters.js";

for (let key in filter) {
  Vue.filter(key, filter[key]);
}

//axios请求
import axios from "./axios/axios";
import api from "./axios/api";

//公共方法
import { numberHandle, mathJs } from "@/utils/index.js";

//rem适配
import remSize from "./utils/remSize.js";
remSize();

//国际化
import i18n from "./utils/i18n/index";

//ui类库、公共组件
import "./utils/Ui-library/element-ui.js";
import "./utils/Ui-library/vant-ui.js";

//detadog监控
import { detadogMonitor } from "@/utils/publicRequest.js";
detadogMonitor();

//阿里云接口埋点
import "@/utils/aliyunBurialPoint.js";
import "@/utils/updatedVersion.js";

// ichatdata 埋点;
import "@/utils/ichatdata.js";

import VConsole from "vconsole";
if (
  !["sbx", "production"].includes(process.env.VUE_APP_TITLE) &&
  process.env.NODE_ENV !== "local"
) {
  new VConsole();
}

//portal埋点
import "@/utils/portal.js";

//登陆风险账号弹框全局方法
Vue.prototype.isKycLoginToast = function () {
  router.push("/accountsDisabled");
};

import VueClipBoard from "vue-clipboard2";
Vue.use(VueClipBoard);

Vue.prototype.$api = api;
Vue.prototype.$axios = axios;
Vue.prototype.$numberHandle = numberHandle;
Vue.prototype.$mathJs = mathJs;

Vue.config.productionTip = false;

try {
  //存储重新复制store数据
  if (sessionStorage.getItem("store")) {
    store.replaceState(
      Object.assign(
        {},
        store.state,
        JSON.parse(sessionStorage.getItem("store"))
      )
    );
  }
} catch (e) {
  console.error("存储重新复制store数据", e);
}

window.vm = new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
